import { colors } from '@constants/colors';
import { IStyles } from '@interfaces/styles';

export const useStyles = (size: number): IStyles => {
  return {
    button: {
      width: size,
      height: size,
      minWidth: 'auto',
      padding: 0,
      fontFamily: 'var(--primary-font-medium)',
      fontSize: Math.round(size * 0.53),
      lineHeight: 1,
      color: colors.white,
      cursor: 'default',
      borderRadius: '8px',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      boxShadow: '0px 2px 4px 0px #00000040',
      background: 'rgba(28, 28, 34, 0.75)',

      '&:hover': {
        background: 'rgba(28, 28, 34, 0.75)',
      },
    },
  };
};
